import FormatService from './format-service';
import { SORT_TYPE_ASC } from '../constants/system/sort-types';
import { REGEXP_TEMPLATE_ALL_NON_FLOAT_SYMBOLS } from '../constants/system/regexp-templates';
import { SIGN_DOT } from '../constants/system/signs';

export default class SortService {
  public static sort(rows: SortRow[], sortParams: SortOptions): SortRow[] {
    const stabilizedRows: [SortRow, number][] = rows.map((item: SortRow, index: number): [SortRow, number] => (
      [item, index]
    ));

    stabilizedRows.sort((rowA: [SortRow, number], rowB: [SortRow, number]): number => {
      const sortResult: number = this.processSort(
        rowA[0], rowB[0], sortParams.field, sortParams.isNumber, sortParams.type,
      );

      if (sortResult !== 0) {
        return sortResult;
      }

      return rowA[1] - rowB[1];
    });

    return stabilizedRows.map((stabilizedRow: [SortRow, number]): SortRow => stabilizedRow[0]);
  }

  private static processSort(
    rowA: SortRow,
    rowB: SortRow,
    fieldName: string,
    isNumber?: boolean,
    sortType?: string,
  ): number {
    let result: number = 0;
    const elementA: string | number = isNumber ? this.prepareNumberRowElement(rowA, fieldName)
      : this.prepareStringRowElement(rowA, fieldName);
    const elementB: string | number = isNumber ? this.prepareNumberRowElement(rowB, fieldName)
      : this.prepareStringRowElement(rowB, fieldName);

    if (isNumber) {
      if (elementB < elementA) {
        result = -1;
      }

      if (elementB > elementA) {
        result = 1;
      }
    } else {
      result = (elementB ? (elementB as string).toLowerCase() : '').localeCompare((elementA as string).toLowerCase());
    }

    if (sortType === SORT_TYPE_ASC) {
      result *= -1;
    }

    return result;
  }

  private static prepareNumberRowElement(row: SortRow, fieldName: string): number {
    const element: string | null = this.prepareRowElement(row, fieldName);

    return Number(element && element.toString().replace(REGEXP_TEMPLATE_ALL_NON_FLOAT_SYMBOLS, ''));
  }

  private static prepareStringRowElement(row: SortRow, fieldName: string): string {
    const element: string | null = this.prepareRowElement(row, fieldName);

    return element || '';
  }

  private static prepareRowElement(row: SortRow, fieldName: string): string | null {
    let element: string | null;

    const isNestedField: boolean = fieldName.indexOf(SIGN_DOT) !== FormatService.INDEX_NOT_FOUND;
    if (isNestedField) {
      const nestedElementPath: string[] = fieldName.split(SIGN_DOT);

      element = nestedElementPath.reduce((previousElement: SortRow, currentElement: string): SortRow => (
        previousElement && previousElement[currentElement]
      ), row);
    } else {
      element = row[fieldName] || null;
    }

    return element;
  }
}
